import React from "react";
import styled from "styled-components";

export default function MaxBookedInput(props) {
  const { value, setValue, placeholder } = props;

  // 변수 변경시 //
  function onChange(e) {
    setValue(e.target.value);
  }

  return (
    <InputBox>
      <Input
        value={value}
        onChange={onChange}
        placeholder={placeholder}/>
    </InputBox>
  );
}

const InputBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  width: 176px;
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

  opacity: ${props => props.isLock ? 0 : 1};

  margin: 0 0 0 0;

  width: 100%;
  height: 75%;

	outline: none;
  border: 0px solid #CBCBCB;

	color: #000000;

  text-align: right;

	::placeholder {
    font-family: NotoSansKR-Regular;
    font-size: 14px;
    
		color: #CBCBCB;
	}

  transition: all 0.3s ease-in-out;
`;
